export default "__VITE_ASSET__YUvu8rpE__"